
import React from "react";
import styled from "styled-components";

export const DirectionText = (props) => {
  const { platform_code } = props;

  const DecideText = (platform_code) => {
    switch (platform_code) {
      case "1":
        return (
          <SDivSmall>
            <p>
              沼津港方面
              <br />
              Numazu Port
            </p>
          </SDivSmall>
        );
      case "2":
        return (
          <SDiv>
            <p>
              我入道
              <br />
              ・ 下香貫方面
              <br />
              Ganyudo
              <br />/ Shimokanuki
            </p>
          </SDiv>
        );
      case "3":
        return (
          <SDiv>
            <p>
              西浦
              <br />
              ・ 伊豆長岡駅方面
              <br />
              Nishiura
              <br />/ Izunagaoka Sta.
            </p>
          </SDiv>
        );
      case "4":
        return (
          <SDivSmall>
            <p>
              大平方面
              <br />
              Ohira
            </p>
          </SDivSmall>
        );
      case "5":
        return (
          <SDivSmall>
            <p>
              清水町方面
              <br />
              Shimizucho
            </p>
          </SDivSmall>
        );
      case "6":
        return (
          <SDivSmall>
            <p>
              大岡方面
              <br />
              Ooka
            </p>
          </SDivSmall>
        );
      case "7":
        return (
          <SDiv7>
            門池
            <br />
            ・ 免許センター方面
            <br />
            Kadoike
            <br />
            /Driver’s License Center
          </SDiv7>
        );
      case "8":
        return (
          <SDiv>
            <p>
              ららぽーと
              <br />
              ・ 市立病院方面
              <br />
              LaLaport
              <br />/ City Hospital
            </p>
          </SDiv>
        );
      case "9":
        return (
          <SDivSmall>
            <p>
              片浜・原方面
              <br />
              Katahama/Hara
            </p>
          </SDivSmall>
        );

      default:
        return <p>None</p>;
    }
  };

  return <>{DecideText(platform_code)}</>;
};

const SDiv = styled.div`
  line-height: 25px; 
  letter-spacing: -0.5px;
`;

const SDivSmall = styled.div`
  line-height: 30px; 
  letter-spacing: -0.5px;
`;

const SDiv7 = styled(SDiv)`
  letter-spacing: -2.5px;
`;
